import { DietType } from './types'
import type { World } from './world'

export class Renderer {
  private ctx: CanvasRenderingContext2D
  private width: number
  private height: number

  constructor(canvas: HTMLCanvasElement) {
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Canvas 2D context not available')
    this.ctx = ctx
    this.width = canvas.width
    this.height = canvas.height
  }

  resize(w: number, h: number): void {
    this.width = w
    this.height = h
  }

  render(world: World): void {
    const ctx = this.ctx

    // 背景
    ctx.fillStyle = '#0a0e1a'
    ctx.fillRect(0, 0, this.width, this.height)

    // 食料
    for (const food of world.foods) {
      ctx.beginPath()
      ctx.arc(food.pos.x, food.pos.y, food.radius, 0, Math.PI * 2)
      ctx.fillStyle = '#3ddc84'
      ctx.shadowColor = '#3ddc84'
      ctx.shadowBlur = 6
      ctx.fill()
      ctx.shadowBlur = 0
    }

    // 生物
    for (const org of world.organisms) {
      const { traits, pos, energy } = org
      const energyRatio = energy / 150

      // 本体
      ctx.beginPath()
      ctx.arc(pos.x, pos.y, traits.size, 0, Math.PI * 2)

      const saturation = 70 + energyRatio * 30
      const lightness = 35 + energyRatio * 30
      ctx.fillStyle = `hsl(${traits.hue}, ${saturation}%, ${lightness}%)`
      ctx.shadowColor = `hsl(${traits.hue}, 100%, 60%)`
      ctx.shadowBlur = traits.diet === DietType.Carnivore ? 8 : 4
      ctx.fill()
      ctx.shadowBlur = 0

      // 輪郭（食性ごとに形状を変える）
      ctx.beginPath()
      ctx.arc(pos.x, pos.y, traits.size, 0, Math.PI * 2)
      ctx.strokeStyle = `hsla(${traits.hue}, 100%, 80%, 0.6)`
      ctx.lineWidth = 1
      ctx.stroke()

      // 速度ベクトル表示（速い個体のみ）
      if (traits.speed > 2.0) {
        const vlen = Math.sqrt(org.vel.x ** 2 + org.vel.y ** 2)
        if (vlen > 0.1) {
          const nx = org.vel.x / vlen
          const ny = org.vel.y / vlen
          ctx.beginPath()
          ctx.moveTo(pos.x, pos.y)
          ctx.lineTo(pos.x + nx * traits.size * 2, pos.y + ny * traits.size * 2)
          ctx.strokeStyle = `hsla(${traits.hue}, 100%, 90%, 0.4)`
          ctx.lineWidth = 1
          ctx.stroke()
        }
      }
    }
  }

  renderStats(world: World, fps: number): void {
    const ctx = this.ctx
    const s = world.stats
    ctx.fillStyle = 'rgba(0,0,0,0.5)'
    ctx.fillRect(8, 8, 200, 80)
    ctx.fillStyle = '#e0e0e0'
    ctx.font = '13px monospace'
    ctx.fillText(`FPS: ${fps.toFixed(0)}`, 16, 26)
    ctx.fillText(`生物数: ${s.organisms}`, 16, 44)
    ctx.fillText(`食料数: ${s.foods}`, 16, 62)
    ctx.fillText(`Tick: ${s.tick}`, 16, 80)
  }
}
